import React from "react";
import { updateFirstStepGeneralFields } from "../../../../../../../redux/reducers/claimReducer";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import CustomRadioGroup from "../../../../../../../Components/CustomInputs/CustomRadioGroup";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const HasHealthProblemsBeforeField: React.FC = () => {
   const fieldNameLowerCase = "hasHealthProblemsBefore";
   const fieldNameUpperCase =
      fieldNameLowerCase.charAt(0).toUpperCase() + fieldNameLowerCase.slice(1);
   const dispatch = useDispatch();

   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase[fieldNameLowerCase]
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   const { isChild, isThirdPerson } = useSelector(
      (state: StoreType) => state.claimState.reportModel
   );
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, fieldNameUpperCase);
   return (
      <WholeLineContainer
         dependencyValue={shouldRenderSpecField(
            "GeneralFields",
            fieldNameUpperCase,
            visibilityMatrixes
         )}
      >
         <CustomRadioGroup
            heading={
               isChild
                  ? "Mělo dítě dříve podobné onemocnění nebo úraz?"
                  : isThirdPerson
                  ? "Měla pojištěná osoba již dříve podobné onemocnění nebo úraz?"
                  : "Měl/a jste již dříve podobné onemocnění nebo úraz?"
            }
            firstLabel="Ano"
            secondLabel="Ne"
            value={fieldValue}
            updateFunc={(e: any) => {
               dispatch(
                  updateFirstStepGeneralFields({
                     value: e === "true" ? true : false,
                     field: fieldNameLowerCase,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               fieldNameUpperCase,
               claimFieldErrorsMessages
            )}
            inputRef={ref}
         />
      </WholeLineContainer>
   );
};

export default HasHealthProblemsBeforeField;
